import React from "react";
import './style.css';

const Loader_6 = () =>{
  return(
    <div className="loader-6">
      <div className="progress"></div>
      <div className="progress"></div>
      <div className="progress"></div>
    </div>
  );
}
export default Loader_6;